import {ModelBase} from '../abstract/model-base';

export class OrderDetailsOrderTag extends ModelBase {
    public id: string;
    public name: string;
    public createdAt: string;

    constructor() {
        super();
    }

    mapModel(data: any): OrderDetailsOrderTag {
        const model = new OrderDetailsOrderTag();

        model.id = data.id;
        model.name = data.name;
        model.createdAt = data.createdAt;

        return model;
    }
}
